import React, { Component } from 'react';

import { Modal, ListGroup, ListGroupItem } from 'react-bootstrap';

export default class ScheduledEvents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteModal: false,
      event: {},
    };
    this.handleObject = this.handleObject.bind(this);
    this.displayDeleteConfirm = this.displayDeleteConfirm.bind(this);
  }

  // TODO: refactor function to prevent ESlint errors
  handleObject(param, id) {
    let returnString = '';
    switch (id) {
      case 'stockingSchedule':
        // eslint-disable-next-line no-case-declarations
        const dow = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
        // TODO: refactor loop to prevent "no-restricted-syntax" error
        // eslint-disable-next-line no-restricted-syntax
        for (const i in dow) {
          // eslint-disable-next-line no-prototype-builtins
          if (param.hasOwnProperty(dow[i]) && param[dow[i]] === 1) {
            returnString = `${returnString + dow[i]}; `;
          }
        }
        break;
      default:
        // Check if param is 'true', 'false', 0, or 1 and return accordingly
        if (param === 'true' || param === 'false') {
          returnString = param;
        } else if (param === 0) {
          returnString = 'false';
        } else if (param === 1) {
          returnString = 'true';
        } else {
          returnString = JSON.stringify(param);
        }
    }
    return returnString;
  }

  displayDeleteConfirm(event) {
    this.setState({
      deleteModal: true,
      event,
    });
  }

  render() {
    return (
      <div>
        <Modal show={this.state.deleteModal}>
          <Modal.Header>
            <Modal.Title>Edit & Delete Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>How would you like to proceed?</Modal.Body>
          <Modal.Footer>
            &nbsp;
            <button
              onClick={() => this.setState({ deleteModal: false })}
              type="button"
              className="btn modalButtons btn-info"
            >
              Close
            </button>
            <button
              onClick={() => {
                this.setState({ deleteModal: false });
                this.props.deleteScheduleAction(this.state.event);
              }}
              type="button"
              className="btn modalButtons btn-warning"
            >
              Delete
            </button>
            {this.props.completeScheduleAction && (
              <button
                onClick={() => {
                  this.setState({ deleteModal: false });
                  this.props.completeScheduleAction(this.state.event);
                }}
                type="button"
                className="btn modalButtons btn-success"
              >
                Complete Now
              </button>
            )}
            {this.props.editScheduleAction && (
              <button
                onClick={() => {
                  this.setState({ deleteModal: false });
                  this.props.editScheduleAction(this.state.event);
                }}
                type="button"
                className="btn modalButtons btn-success"
              >
                Edit
              </button>
            )}
          </Modal.Footer>
        </Modal>
        {Object.keys(this.props.events).filter(
          (ind) => this.props.events[ind].change.attribute === this.props.id,
        ).length > 0 && (
          <ListGroup>
            <ListGroupItem header="Scheduled Changes:" />
            {Object.keys(this.props.events)
              .filter(
                (ind) =>
                  this.props.events[ind].change.attribute === this.props.id,
              )
              .map((ind) => (
                <ListGroupItem
                  key={this.props.events[ind].uuid}
                  onClick={() =>
                    this.displayDeleteConfirm(this.props.events[ind])
                  }
                  header={`${new Date(
                    this.props.events[ind].actionTime,
                  ).toLocaleDateString('en-US')} ${new Date(
                    this.props.events[ind].actionTime,
                  ).toLocaleTimeString('en-US', { hour12: false })}`}
                >
                  {this.handleObject(
                    this.props.events[ind].change.value,
                    this.props.id,
                  )}
                </ListGroupItem>
              ))}
          </ListGroup>
        )}
        {!Object.keys(this.props.events).filter(
          (ind) => this.props.events[ind].change.attribute === this.props.id,
        ).length > 0 && (
          <ListGroup>
            <ListGroupItem href="#NoItems" header="No Scheduled Changes" />
          </ListGroup>
        )}
      </div>
    );
  }
}
